import { isDevSite } from "../../utils/general";

const PRODUCT_ID_PROD = 'prod_J8jz9uooW4PLna';
const PRODUCT_ID_DEV = 'prod_J8kEW4NCKrP3nK';

const PRICE_ID_YEARLY_PROD = 'price_1KfVHbKnX1nnNv6I4wEA7d2K';
const PRICE_ID_YEARLY_DEV = 'price_1KfVUXKnX1nnNv6IRgoMTn6b';

const PRICE_ID_MONTHLY_PROD = 'price_1KfV77KnX1nnNv6Iw1tVuVWl';
const PRICE_ID_MONTHLY_DEV = 'price_1KfVScKnX1nnNv6IzFaboaWJ';

const PADDLE_PRICE_ID_YEARLY_PROD = 761274;
const PADDLE_PRICE_ID_YEARLY_DEV = 20462;

const PADDLE_PRICE_ID_MONTHLY_PROD = 761272;
const PADDLE_PRICE_ID_MONTHLY_DEV = 20461;

const PADDLE_PRICE_ID_YEARLY = isDevSite() ? PADDLE_PRICE_ID_YEARLY_DEV : PADDLE_PRICE_ID_YEARLY_PROD;
const PADDLE_PRICE_ID_MONTHLY = isDevSite() ? PADDLE_PRICE_ID_MONTHLY_DEV : PADDLE_PRICE_ID_MONTHLY_PROD;

const PRODUCT_ID = isDevSite() ? PRODUCT_ID_DEV : PRODUCT_ID_PROD
const PRICE_ID_YEARLY = isDevSite() ? PRICE_ID_YEARLY_DEV : PRICE_ID_YEARLY_PROD;
const PRICE_ID_MONTHLY = isDevSite() ? PRICE_ID_MONTHLY_DEV : PRICE_ID_MONTHLY_PROD;

const PRO_U_PLAN = {
  id: PRODUCT_ID,
  label: 'Pro',
  prices: {
    yearly: { id: PRICE_ID_YEARLY, value: 372, paddleLink: 'https://buy.paddle.com/product/761274', paddleId: PADDLE_PRICE_ID_YEARLY },
    monthly: { id: PRICE_ID_MONTHLY, value: 38, paddleLink: 'https://buy.paddle.com/product/761272',paddleId: PADDLE_PRICE_ID_MONTHLY }
  },
  fileSizeLimit: 1000,
  customDomainsLimit: 5,
  projectLimit: 12
}

export default PRO_U_PLAN;
